import { Component, OnInit } from '@angular/core';
import { DashboardHelper } from '../../../services/dashboard.service';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { AboutCatchComponent } from '../about-catch/about-catch.component';

@Component({
  selector: 'app-profileandchangepwd',
  templateUrl: './profile-and-change-password.component.html',
  styleUrls: ['./profile-and-change-password.component.css'],
  standalone: false,
})
export class ProfileAndChangePasswordComponent implements OnInit {
  constructor(private dashboardService: DashboardHelper) {}

  ngOnInit() {
    this.dashboardService.setShowRightPanel(true);
    this.dashboardService.setExpandRightPanel(false);
  }
}
